import { Header } from '@/shared/components/ui/layout'

import { AnchorFamiliesBulkDecision } from '../AnchorFamiliesBulkDecision'
import ApprovalTableToolbar from './ApprovalTableToolbar'
import ApprovalTableViewToggle from './ApprovalTableViewToggle'

export default function ApprovalTableHeader() {
	return (
		<Header className='shrink-0 items-center space-x-2 py-2'>
			<ApprovalTableToolbar />
			<div className='flex w-full items-center justify-between'>
				<ApprovalTableViewToggle />
				<AnchorFamiliesBulkDecision />
			</div>
		</Header>
	)
}
